import { MenuItem } from './index'

export const sofiaMenu: MenuItem[] = [
  {
    id: 'shopByBrand',
    label: 'Shop By Brand',
    url: '/shop-by-brand',
    items: [
      {
        id: 'always',
        parentId: 'shopByBrand',
        label: 'Always',
        url: '/shop-by-brand/always-discreet',
        render: 'image',
        image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-always.png`,
        items: [
          {
            id: 'liners',
            parentId: 'always',
            label: 'Liners',
            url: '/shop-by-brand/always-discreet/liners'
          },
          {
            id: 'pads',
            parentId: 'always',
            label: 'Pads',
            url: '/shop-by-brand/always-discreet/pads'
          },
          {
            id: 'underwear',
            parentId: 'always',
            label: 'Underwear',
            url: '/shop-by-brand/always-discreet/underwear'
          }
        ]
      },
      {
        id: 'depend',
        parentId: 'shopByBrand',
        label: 'Depend',
        url: '/shop-by-brand/depend',
        render: 'image',
        image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-depend.png`,
        items: [
          {
            id: 'underwear',
            parentId: 'depend',
            label: 'Underwear',
            url: '/shop-by-brand/depend/underwear'
          }
        ]
      },
      {
        id: 'olana',
        parentId: 'shopByBrand',
        label: 'Olana',
        url: '/shop-by-brand/olana',
        render: 'image',
        image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-olana.png`,
        items: [
          {
            id: 'pads',
            parentId: 'olana',
            label: 'Pads',
            url: '/shop-by-brand/olana/pads'
          },
          {
            id: 'underwear',
            parentId: 'olana',
            label: 'Underwear',
            url: '/shop-by-brand/olana/underwear'
          }
        ]
      },
      {
        id: 'poise',
        parentId: 'shopByBrand',
        label: 'Poise',
        url: '/shop-by-brand/poise',
        render: 'image',
        image: `${process.env.REACT_APP_MAGENTO_URI}/media/brand-logos/Poise_Logos_One_Color_Mob.png`,
        items: [
          {
            id: 'liners',
            parentId: 'poise',
            label: 'Liners',
            url: '/shop-by-brand/poise/liners'
          },
          {
            id: 'pads',
            parentId: 'poise',
            label: 'Pads',
            url: '/shop-by-brand/poise/pads'
          }
        ]
      },
      {
        id: 'rael',
        parentId: 'shopByBrand',
        label: 'Rael',
        url: '/shop-by-brand/rael',
        render: 'image',
        image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/rael-logo.png`,
        items: [
          {
            id: 'liners',
            parentId: 'rael',
            label: 'Liners',
            url: '/shop-by-brand/rael/liners'
          },
          {
            id: 'pads',
            parentId: 'rael',
            label: 'Pads',
            url: '/shop-by-brand/rael/pads'
          }
        ]
      },
      {
        id: 'tena',
        parentId: 'shopByBrand',
        label: 'Tena',
        url: '/shop-by-brand/tena',
        render: 'image',
        image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-tena.png`,
        items: [
          {
            id: 'liners',
            parentId: 'tena',
            label: 'Liners',
            url: '/shop-by-brand/tena/liners'
          },
          {
            id: 'pads',
            parentId: 'tena',
            label: 'Pads',
            url: '/shop-by-brand/tena/pads'
          },
          {
            id: 'underwear',
            parentId: 'tena',
            label: 'Underwear',
            url: '/shop-by-brand/tena/underwear'
          }
        ]
      }
    ]
  },
  {
    id: 'shopProducts',
    label: 'Shop Products',
    url: '/bladder-control',
    items: [
      {
        id: 'bladderControl',
        parentId: 'shopProducts',
        label: 'Bladder Control',
        url: '/bladder-control',
        items: [
          {
            id: 'allTypes',
            parentId: 'bladderControl',
            label: 'All Types of Leakage',
            url: '/bladder-control',
            items: [
              {
                id: 'liners',
                parentId: 'allTypes',
                label: 'Liners',
                url: '/incontinence-liners'
              },
              {
                id: 'pads',
                parentId: 'allTypes',
                label: 'Pads',
                url: '/incontinence-pads'
              },
              {
                id: 'underwear',
                parentId: 'allTypes',
                label: 'Underwear',
                url: '/incontinence-underwear'
              }
            ]
          },
          {
            id: 'drip',
            parentId: 'bladderControl',
            label: 'Drip',
            url: '/bladder-control#/ps/12/primary_bladder_leakage/5455/p/1/',
            render: 'text-icon',
            icon: 'icon-drip',
            items: [
              {
                id: 'always',
                parentId: 'drip',
                label: 'Always',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5455/p/1/manufacturer/5454/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-always.png`
              },
              {
                id: 'olana',
                parentId: 'drip',
                label: 'Olana',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5455/p/1/manufacturer/5532/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-olana.png`
              },
              {
                id: 'poise',
                parentId: 'drip',
                label: 'Poise',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5455/p/1/manufacturer/5476/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/brand-logos/Poise_Logos_One_Color_Mob.png`
              },
              {
                id: 'tena',
                parentId: 'drip',
                label: 'Tena',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5455/p/1/manufacturer/5474/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-tena.png`
              },
              {
                id: 'showAll',
                parentId: 'drip',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5455/p/1/'
              }
            ]
          },
          {
            id: 'dribble',
            parentId: 'bladderControl',
            label: 'Dribble',
            url: '/bladder-control#/ps/12/primary_bladder_leakage/5456/p/1/',
            render: 'text-icon',
            icon: 'icon-dribble',
            items: [
              {
                id: 'always',
                parentId: 'dribble',
                label: 'Always',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5456/p/1/manufacturer/5454/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-always.png`
              },
              {
                id: 'olana',
                parentId: 'dribble',
                label: 'Olana',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5456/p/1/manufacturer/5532/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-olana.png`
              },
              {
                id: 'poise',
                parentId: 'dribble',
                label: 'Poise',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5456/p/1/manufacturer/5476/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/brand-logos/Poise_Logos_One_Color_Mob.png`
              },
              {
                id: 'tena',
                parentId: 'drip',
                label: 'Tena',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5456/p/1/manufacturer/5474/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-tena.png`
              },
              {
                id: 'showAll',
                parentId: 'dribble',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5456/p/1/'
              }
            ]
          },
          {
            id: 'gush',
            parentId: 'bladderControl',
            label: 'Gush',
            url: '/bladder-control#/ps/12/primary_bladder_leakage/5457/p/1/',
            render: 'text-icon',
            icon: 'icon-gush',
            items: [
              {
                id: 'always',
                parentId: 'gush',
                label: 'Always',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5457/p/1/manufacturer/5454/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-always.png`
              },
              {
                id: 'depend',
                parentId: 'gush',
                label: 'Depend',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5457/p/1/manufacturer/5472/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-depend.png`
              },
              {
                id: 'olana',
                parentId: 'gush',
                label: 'Olana',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5457/p/1/manufacturer/5532/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-olana.png`
              },
              {
                id: 'poise',
                parentId: 'gush',
                label: 'Poise',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5457/p/1/manufacturer/5476/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/brand-logos/Poise_Logos_One_Color_Mob.png`
              },
              {
                id: 'tena',
                parentId: 'gush',
                label: 'Tena',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5457/p/1/manufacturer/5474/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-tena.png`
              },
              {
                id: 'showAll',
                parentId: 'gush',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5457/p/1/'
              }
            ]
          },
          {
            id: 'heavyFlow',
            parentId: 'bladderControl',
            label: 'Heavy Flow',
            url: '/bladder-control#/ps/12/primary_bladder_leakage/5458/p/1/',
            render: 'text-icon',
            icon: 'icon-heavy-flow',
            items: [
              {
                id: 'always',
                parentId: 'heavyFlow',
                label: 'Always',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5458/p/1/manufacturer/5454/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-always.png`
              },
              {
                id: 'poise',
                parentId: 'heavyFlow',
                label: 'Poise',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5458/p/1/manufacturer/5476/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/brand-logos/Poise_Logos_One_Color_Mob.png`
              },
              {
                id: 'tena',
                parentId: 'heavyFlow',
                label: 'Tena',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5458/p/1/manufacturer/5474/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-tena.png`
              },
              {
                id: 'showAll',
                parentId: 'heavyFlow',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5458/p/1/'
              }
            ]
          },
          {
            id: 'flooding',
            parentId: 'bladderControl',
            label: 'Flooding',
            url: '/bladder-control#/ps/12/primary_bladder_leakage/5459/p/1/',
            render: 'text-icon',
            icon: 'icon-flooding',
            items: [
              {
                id: 'reassure',
                parentId: 'flooding',
                label: 'Reassure',
                url: 'bladder-control#/ps/12/primary_bladder_leakage/5459/p/1/manufacturer/5473/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-reassure.png`
              },
              {
                id: 'showAll',
                parentId: 'flooding',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5459/p/1/'
              }
            ]
          }
        ]
      },
      {
        id: 'menopause',
        parentId: 'shopProducts',
        label: 'Menopause',
        url: '/menopause'
      },
      {
        id: 'kegel',
        parentId: 'shopProducts',
        label: 'Kegel',
        url: '/kegel'
      },
      {
        id: 'intimateSelfCare',
        parentId: 'shopProducts',
        label: 'Intimate Self Care',
        url: '/intimate-self-care'
      },
      {
        id: 'healthBeauty',
        parentId: 'shopProducts',
        label: 'Health & Beauty',
        url: '/health-beauty'
      },
      {
        id: 'periodCare',
        parentId: 'shopProducts',
        label: 'Period Care',
        url: '/period-care'
      },
      {
        id: 'caregiving',
        parentId: 'shopProducts',
        label: 'Caregiving',
        url: '/caregiving'
      }
    ]
  },
  {
    id: 'community',
    label: 'Community',
    url: '',
    items: [
      {
        id: 'blog',
        parentId: 'community',
        label: 'Graceful Living Blog',
        url: '/blog'
      },
      {
        id: 'community1',
        parentId: 'community',
        label: 'Community',
        url: '/community'
      },
      {
        id: 'story',
        parentId: 'community',
        label: 'Our Story',
        url: '/story'
      },
      {
        id: 'faq',
        parentId: 'community',
        label: 'FAQs',
        url: '/faq'
      }
    ]
  }
]

export const livBriteMenu: MenuItem[] = [
  {
    id: 'shopProducts',
    label: 'Shop Products',
    url: '/bladder-control',
    items: [
      {
        id: 'bladderControl',
        parentId: 'shopProducts',
        label: 'Bladder Control',
        url: '/bladder-control',
        items: [
          {
            id: 'allTypes',
            parentId: 'bladderControl',
            label: 'All Types of Leakage',
            url: '/bladder-control',
            items: [
              {
                id: 'pads',
                parentId: 'allTypes',
                label: 'Pads',
                url: '/incontinence-pads'
              },
              {
                id: 'underwear',
                parentId: 'allTypes',
                label: 'Underwear',
                url: '/incontinence-underwear'
              },
              {
                id: 'briefs',
                parentId: 'allTypes',
                label: 'Briefs',
                url: '/incontinence-briefs'
              },
              {
                id: 'male-guards',
                parentId: 'allTypes',
                label: 'Male Guards',
                url: '/incontinence-male-guards'
              }
            ]
          },
          {
            id: 'drip',
            parentId: 'bladderControl',
            label: 'Drip',
            url: '/bladder-control#/ps/12/primary_bladder_leakage/5455/p/1/',
            render: 'text-icon',
            icon: 'icon-drip',
            items: [
              {
                id: 'reassure',
                parentId: 'drip',
                label: 'Reassure',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5473/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-reassure.png`
              },
              {
                id: 'showAll',
                parentId: 'drip',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/primary_bladder_leakage/5455/p/1/'
              }
            ]
          },
          {
            id: 'dribble',
            parentId: 'bladderControl',
            label: 'Dribble',
            url: '/bladder-control#/ps/12/p/1/primary_bladder_leakage/5456/',
            render: 'text-icon',
            icon: 'icon-dribble',
            items: [
              {
                id: 'depend',
                parentId: 'dribble',
                label: 'Depend',
                url: '/bladder-control#/ps/12/manufacturer/5472/p/1/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-depend.png`
              },
              {
                id: 'poise',
                parentId: 'dribble',
                label: 'Poise',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5476/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/brand-logos/Poise_Logos_One_Color_Mob.png`
              },
              {
                id: 'reassure',
                parentId: 'drip',
                label: 'Reassure',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5473/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-reassure.png`
              },
              {
                id: 'showAll',
                parentId: 'dribble',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/p/1/primary_bladder_leakage/5456/'
              }
            ]
          },
          {
            id: 'gush',
            parentId: 'bladderControl',
            label: 'Gush',
            url: '/bladder-control#/ps/12/p/1/primary_bladder_leakage/5457/',
            render: 'text-icon',
            icon: 'icon-gush',
            items: [
              {
                id: 'attends-premiere',
                parentId: 'gush',
                label: 'Attends Premiere',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5561/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-attends.png`
              },
              {
                id: 'depend',
                parentId: 'gush',
                label: 'Depend',
                url: '/bladder-control#/ps/12/manufacturer/5472/p/1/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-depend.png`
              },
              {
                id: 'poise',
                parentId: 'gush',
                label: 'Poise',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5476/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/brand-logos/Poise_Logos_One_Color_Mob.png`
              },
              {
                id: 'reassure',
                parentId: 'gush',
                label: 'Reassure',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5473/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-reassure.png`
              },
              {
                id: 'showAll',
                parentId: 'gush',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/p/1/primary_bladder_leakage/5457/'
              }
            ]
          },
          {
            id: 'heavyFlow',
            parentId: 'bladderControl',
            label: 'Heavy Flow',
            url: '/bladder-control#/ps/12/p/1/primary_bladder_leakage/5458/',
            render: 'text-icon',
            icon: 'icon-heavy-flow',
            items: [
              {
                id: 'attends-premiere',
                parentId: 'heavyFlow',
                label: 'Attends Premiere',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5561/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-attends.png`
              },
              {
                id: 'depend',
                parentId: 'heavyFlow',
                label: 'Depend',
                url: '/bladder-control#/ps/12/manufacturer/5472/p/1/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-depend.png`
              },
              {
                id: 'poise',
                parentId: 'heavyFlow',
                label: 'Poise',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5476/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/brand-logos/Poise_Logos_One_Color_Mob.png`
              },
              {
                id: 'reassure',
                parentId: 'heavyFlow',
                label: 'Reassure',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5473/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-reassure.png`
              },
              {
                id: 'showAll',
                parentId: 'heavyFlow',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/p/1/primary_bladder_leakage/5458/'
              }
            ]
          },
          {
            id: 'flooding',
            parentId: 'bladderControl',
            label: 'Flooding',
            url: '/bladder-control#/ps/12/p/1/primary_bladder_leakage/5459/',
            render: 'text-icon',
            icon: 'icon-flooding',
            items: [
              {
                id: 'attends-premiere',
                parentId: 'flooding',
                label: 'Attends Premiere',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5561/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-attends.png`
              },
              {
                id: 'depend',
                parentId: 'flooding',
                label: 'Depend',
                url: '/bladder-control#/ps/12/manufacturer/5472/p/1/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-depend.png`
              },
              {
                id: 'reassure',
                parentId: 'flooding',
                label: 'Reassure',
                url: '/bladder-control#/ps/12/p/1/manufacturer/5473/',
                render: 'image',
                image: `${process.env.REACT_APP_MAGENTO_URI}/media/megamenu/brands-reassure.png`
              },
              {
                id: 'showAll',
                parentId: 'flooding',
                label: 'Show Me Everything',
                url: '/bladder-control#/ps/12/p/1/primary_bladder_leakage/5459/'
              }
            ]
          }
        ]
      },
      {
        id: 'mobility',
        parentId: 'shopProducts',
        label: 'Mobility',
        url: '/mobility'
      },
      {
        id: 'nutrition',
        parentId: 'shopProducts',
        label: 'Nutrition',
        url: '/nutritionals'
      },
      {
        id: 'sleep',
        parentId: 'shopProducts',
        label: 'Sleep',
        url: '/sleep'
      },
      {
        id: 'fallPrevention',
        parentId: 'shopProducts',
        label: 'Fall Prevention',
        url: '/fall-prevention'
      },
      {
        id: 'dailyLiving',
        parentId: 'shopProducts',
        label: 'Daily Living',
        url: '/daily-living'
      }
    ]
  },
  {
    id: 'inspiration',
    label: 'Inspiration and Advice',
    url: '/inspiration-and-advice',
    items: [
      {
        id: 'bladderControl',
        parentId: 'inspiration',
        label: 'Bladder Control',
        url: '/blog/category/bladder-control-articles'
      },
      {
        id: 'mobility',
        parentId: 'inspiration',
        label: 'Mobility',
        url: '/blog/category/mobility-articles'
      },
      {
        id: 'nutrition',
        parentId: 'inspiration',
        label: 'Nutrition',
        url: '/blog/category/nutrition-articles'
      },
      {
        id: 'sleep',
        parentId: 'inspiration',
        label: 'Sleep',
        url: '/blog/category/sleep-articles'
      },
      {
        id: 'fallPrevention',
        parentId: 'inspiration',
        label: 'Fall Prevention',
        url: '/blog/category/fall-prevention-articles'
      },
      {
        id: 'lonelinessAndIsolation',
        parentId: 'inspiration',
        label: 'Loneliness and Isolation',
        url: '/blog/category/loneliness-and-isolation-articles'
      }
    ]
  }
]
